import { useRouter } from 'next/router'
import mapPage from '@/constants/page-map'
import mapProduct from '@/constants/product-map'

export default function useRouteInfo() {
  const { pathname, query } = useRouter()

  const pageName = mapPage(pathname)
  const currentTab =
    query?.tab && !Array.isArray(query.tab) ? query.tab : undefined

  const productName = currentTab ? mapProduct(currentTab) : mapProduct(pathname)

  return { pageName, productName }
}
